/**
 * Correctly use singular or plural for a quantity.
 */
export function quantity(
  value: number,
  singular: string,
  plural: string
): string {
  return String(value) + " " + (value == 1 ? singular : plural);
}

/**
 * Format a date object according to the users locale.
 */
export function datetime(
  value: Date,
  showDate: boolean = true,
  showTime: boolean = true,
  showSeconds: boolean = false
): string {
  return value.toLocaleString(undefined, {
    year: showDate ? "numeric" : undefined,
    month: showDate ? "2-digit" : undefined,
    day: showDate ? "2-digit" : undefined,
    hour: showTime ? "2-digit" : undefined,
    minute: showTime ? "2-digit" : undefined,
    second: showTime && showSeconds ? "2-digit" : undefined
  });
}

/**
 * Format the date part of a date object according to the users locale.
 */
export function date(value: Date): string {
  return datetime(value, true, false, false);
}

/**
 * Format the time part of a date object according to the users locale.
 */
export function time(value: Date, showSeconds: boolean = false): string {
  return datetime(value, false, true, showSeconds);
}

/**
 * Make the first character of the string upper case
 */
export function capitalize(text: string) {
  return text.charAt(0).toUpperCase() + text.substr(1);
}

/**
 * Make the first character of every word upper case
 *
 * Note: Due to the fact that the regular expression class \p{L} is not yet
 * supported in many browsers, we use this shortcut. It will not work for all
 * languages as only the first 10 unicode blocks are included.
 */
export function titlecase(text: string) {
  return text.replace(
    /(?:[A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F])+/gu,
    capitalize
  );
}

interface Address {
  street: string;
  streetNumber: string;
  extra?: string;
  zipCode: string;
  city: string;
}

export function address(address?: Address): string {
  if (!address) {
    return "";
  }
  let output = `${address.street} ${address.streetNumber}, `;
  if (address.extra) {
    output += `${address.extra}, `;
  }
  output += `${address.zipCode} ${address.city}`;
  return output;
}
